import { render } from "./MemoruContent.vue?vue&type=template&id=685b7f8c&ts=true"
import script from "./MemoruContent.vue?vue&type=script&lang=ts"
export * from "./MemoruContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__